import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";
import { LEAD_MAGNET } from "@/content/copy";

export default function ChecklistForm({ idPrefix = "checklist" }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await api.post("/leads/checklist", { name: name || null, email });
      trackEvent("checklist_download", { location: idPrefix });
      navigate("/thank-you?source=checklist");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <form data-testid={`${idPrefix}-form`} onSubmit={submit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <label htmlFor={`${idPrefix}-name`} className="sr-only">First name (optional)</label>
        <input
          id={`${idPrefix}-name`}
          data-testid={`${idPrefix}-name-input`}
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="First name (optional)"
          autoComplete="given-name"
          className="flex-1 rounded-full border-2 border-navy/15 bg-white px-5 py-3.5 text-base text-navy placeholder:text-navy/40 focus:border-terracotta focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta"
        />
        <label htmlFor={`${idPrefix}-email`} className="sr-only">Email address</label>
        <input
          id={`${idPrefix}-email`}
          data-testid={`${idPrefix}-email-input`}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@business.com.au"
          autoComplete="email"
          className="flex-1 rounded-full border-2 border-navy/15 bg-white px-5 py-3.5 text-base text-navy placeholder:text-navy/40 focus:border-terracotta focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta"
        />
        <button
          type="submit"
          data-testid={`${idPrefix}-submit-button`}
          disabled={loading}
          className="rounded-full bg-terracotta px-7 py-3.5 text-base font-bold text-white transition-all duration-300 hover:bg-terracotta-hover hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:hover:translate-y-0 focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 focus-visible:outline-none"
        >
          {loading ? "Sending…" : LEAD_MAGNET.button}
        </button>
      </div>
      <p className="mt-3 text-xs text-navy/50">{LEAD_MAGNET.privacyNote}</p>
    </form>
  );
}
